var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFooterYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.5 35C27.165 35 35 27.165 35 17.5C35 7.83502 27.165 0 17.5 0C7.83502 0 0 7.83502 0 17.5C0 27.165 7.83502 35 17.5 35Z",
    fill: "#A1A1A1",
    className: "app-icon"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5879 13.1857C27.3574 12.331 26.6819 11.6574 25.8252 11.4272C24.2602 11 17.9998 11 17.9998 11C17.9998 11 11.7396 11 10.1745 11.411C9.33438 11.6409 8.64239 12.3312 8.41183 13.1857C8 14.7467 8 17.9841 8 17.9841C8 17.9841 8 21.2378 8.41183 22.7826C8.64254 23.6371 9.3179 24.3109 10.1747 24.541C11.7561 24.9683 18 24.9683 18 24.9683C18 24.9683 24.2602 24.9683 25.8252 24.5573C26.682 24.3273 27.3574 23.6535 27.5881 22.799C27.9999 21.2378 27.9999 18.0006 27.9999 18.0006C27.9999 18.0006 28.0164 14.7467 27.5879 13.1857Z",
    fill: "#E1E1E1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9365 21L21.1746 17.9841L15.9365 14.9683L15.9365 21Z",
    fill: "#5B5B5B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterYoutube);
export default __webpack_public_path__ + "static/media/footer_youtube.6462f950f2d7c522cf105346982cf7a6.svg";
export { ForwardRef as ReactComponent };